<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 v-if="command.id === undefined" slot="header" class="card-title">Création d'une commande</h4>
        <h4 v-if="command.id !== undefined" slot="header" class="card-title">Commande : {{ command.command_number }}</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="backToList()">
            <span><i class="fas fa-arrow-circle-left mr-2"></i> Retour</span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <form ref="command_form" @submit.prevent="save()">
            <div class="row">
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">N° de Commande</label>
                <fg-input placeholder="ex: 12/345678" autocomplete="off" name="command_number" v-validate="'required'" :error="errors.first('command_number')" @focus="duplicateCommandNumber = false"
                          :class="duplicateCommandNumber? 'has-danger':''" v-model="command.command_number" addon-left-icon="now-ui-icons shopping_tag-content" @blur="checkDuplicateCommandNumber"/>
                <slot name="helpBlock">
                  <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="duplicateCommandNumber">
                    Ce numéro de commande est déjà utilisé
                  </div>
                </slot>
              </div>
              <div v-if="command.type !== 'Wi-line'" class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">N° de Commande Client</label>
                <fg-input placeholder="ex: 12345678" autocomplete="off" name="customer_command_number" v-validate="'required'" :error="errors.first('customer_command_number')"
                          v-model="command.customer_command_number" addon-left-icon="now-ui-icons shopping_tag-content"/>
              </div>
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Commercial</label>
                <fg-input class="select" name="commercial_id" v-model="command.commercial_id" v-validate="'required'">
                  <el-select :class="errors.first('commercial_id') ? 'has-error':''" id="role" placeholder="Choisir un commercial" v-model="command.commercial_id" filterable>
                    <el-option v-for="commercial in commercial_select_options" :key="commercial.value" :label="commercial.label" :value="commercial.value"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('commercial_id')">
                      {{ errors.first('commercial_id') }}
                    </div>
                  </slot>
                </fg-input>
              </div>
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Date de la commande</label>
                <fg-input name="command_date" v-model="command.command_date" addon-left-icon="now-ui-icons far fa-calendar-alt" v-validate="'required'" :class="errors.first('command_date') ? 'has-danger':''">
                  <flat-picker ref="command_date" slot-scope="{focus, blur}" :config="flatpickr_config"
                               class="datepicker" :placeholder="'Choisir une date'"
                               v-model="command.command_date">
                  </flat-picker>
                </fg-input>
                <slot name="helpBlock">
                  <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('command_date')">
                    {{ errors.first('command_date') }}
                  </div>
                </slot>

              </div>
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Client</label>
                <fg-input v-show="!customer_select" placeholder="ex: FENWICK LYON" autocomplete="off" name="customer" v-validate="{ required: !this.customer_select }" :error="errors.first('customer')"
                          v-model="command.customer" addon-left-icon="now-ui-icons far fa-building"/>
                <n-button v-show="!customer_select && customer_select_options.length !== 0" :style="errors.first('customer') ? 'margin-top: -72px':''" type="primary" class="btn btn-sm btn-primary active-select" @click.native="customer_select = true">
                  <span><i class="fas fa-th-list"></i></span>
                </n-button>

                <fg-input v-show="customer_select" class="select" name="customer_id" v-model="command.customer_id" v-validate="{ required: this.customer_select }">
                  <el-select :class="errors.first('customer_id') ? 'has-error':''" id="customer_id" placeholder="Choisir un client" v-model="command.customer_id" filterable>
                    <n-button v-show="customer_select" type="primary" class="btn btn-sm btn-primary" style="width: 99%" @click.native="customer_select = false">
                      <span><i class="fas fa-plus-circle mr-2"></i> Ajouter un client</span>
                    </n-button>
                    <el-option v-show="customer_select" v-for="customer in customer_select_options" :key="customer.id" :label="customer.name" :value="customer.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('customer_id')">
                      {{ errors.first('customer_id') }}
                    </div>
                  </slot>
                </fg-input>
              </div>

              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Client final</label>
                <fg-input v-show="!final_customer_select" placeholder="ex: HERTA" autocomplete="off" name="final_customer" v-validate="{ required: !this.final_customer_select }" :error="errors.first('final_customer')"
                          v-model="command.final_customer" addon-left-icon="now-ui-icons far fa-building"/>
                <n-button v-show="!final_customer_select && customer_select_options.length !== 0" :style="errors.first('final_customer') ? 'margin-top: -72px':''" type="primary" class="btn btn-sm btn-primary active-select" @click.native="final_customer_select = true">
                  <span><i class="fas fa-th-list"></i></span>
                </n-button>

                <fg-input v-show="final_customer_select" class="select" name="final_customer_id" v-model="command.final_customer_id" v-validate="{ required: this.final_customer_select }">
                  <el-select :class="errors.first('final_customer_id') ? 'has-error':''" id="final_customer_id" placeholder="Choisir un client final" v-model="command.final_customer_id" filterable>
                      <n-button  v-show="final_customer_select" type="primary" class="btn btn-sm btn-primary" style="width: 99%" @click.native="final_customer_select = false">
                      <span><i class="fas fa-plus-circle mr-2"></i> Ajouter un client final</span>
                    </n-button>
                    <el-option v-show="final_customer_select" v-for="customer in customer_select_options" :key="customer.id" :label="customer.name" :value="customer.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('customer_id')">
                      {{ errors.first('final_customer_id') }}
                    </div>
                  </slot>
                </fg-input>
              </div>
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Situation</label>
                <fg-input placeholder="ex: En cours" autocomplete="off" name="situation" :error="errors.first('situation')"
                          v-model="command.situation" addon-left-icon="now-ui-icons fas fa-info"/>
              </div>
              <div class="col-lg-2 col-md-4 mb-3">
                <label class="input-label">Date de la livraison demandé</label>
                <fg-input name="delivery_date_requested" v-model="command.delivery_date_requested" addon-left-icon="now-ui-icons far fa-calendar-alt">
                  <flat-picker ref="delivery_date_requested" slot-scope="{focus, blur}" :config="flatpickr_config"
                               class="datepicker" :placeholder="'Choisir une date'"
                               v-model="command.delivery_date_requested">
                  </flat-picker>
                </fg-input>
              </div>
              <div class="col-lg-4 col-md-4 mb-3">
                <label class="input-label">Commentaire</label>
                <fg-input placeholder="" autocomplete="off" name="comment" :error="errors.first('comment')"
                          v-model="command.comment" addon-left-icon="now-ui-icons far fa-comment"/>
              </div>
              <div class="col-lg-4 col-md-4 mb-3">
                <label class="input-label">Renseignement</label>
                <fg-input placeholder="" autocomplete="off" name="information" :error="errors.first('information')"
                          v-model="command.information" addon-left-icon="now-ui-icons far fa-comment"/>
              </div>
              <div class="col-lg-3 col-md-4 mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="switch-label">Préparé</label>
                    <div class="switch-input">
                      <n-switch style="margin-top: 15px;" v-model="command.prepared" on-text="Oui" off-text="Non"></n-switch>
                    </div>
                  </div>
                  <div class="col-9">
                    <label class="input-label">Date de préparation</label>
                    <fg-input name="preparation_date" v-model="command.preparation_date" addon-left-icon="now-ui-icons far fa-calendar-alt">
                      <flat-picker ref="delivery_date_requested" slot-scope="{focus, blur}" :config="flatpickr_config"
                                   class="datepicker" :disabled="true" :placeholder="'Choisir une date'"
                                   v-model="command.preparation_date">
                      </flat-picker>
                    </fg-input>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 mb-3">
                <div class="row">
                  <div class="col-3">
                    <label class="switch-label">Livré</label>
                    <div class="switch-input">
                      <n-switch style="margin-top: 15px;" v-model="command.deliver" on-text="Oui" off-text="Non"></n-switch>
                    </div>
                  </div>
                  <div class="col-9">
                    <label class="input-label">Date de départ</label>
                    <fg-input name="departure_date" v-model="command.departure_date" addon-left-icon="now-ui-icons far fa-calendar-alt">
                      <flat-picker ref="departure_date" slot-scope="{focus, blur}" :config="flatpickr_config"
                                   class="datepicker" :disabled="true" :placeholder="'Choisir une date'"
                                   v-model="command.departure_date">
                      </flat-picker>
                    </fg-input>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <label class="switch-label">Stand-By</label>
                <div class="switch-input">
                  <n-switch style="margin-top: 15px;" v-model="command.standby" on-text="Oui" off-text="Non"></n-switch>
                </div>
              </div>
              <div class="col-2">
                <label class="switch-label">Urgent</label>
                <div class="switch-input">
                  <n-switch style="margin-top: 15px;" v-model="command.urgent" on-text="Oui" off-text="Non"></n-switch>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <h4 class="text-center">Liste des articles</h4>

            <!-- Boucle sur les article de la commande  -->
            <card v-for="(article, index_article) in command.articles" :key="index_article">
                <h5 slot="header">{{ article.name }}</h5>
                <div slot="header" style="float: right; margin-top: -45px;">
                  <number-input @update:modelValue="updatemodelValue(index_article, $event)" :model-value="command.articles[index_article].amount" inline center controls :min="1"></number-input>
                </div>
                <div class="row">
                  <div v-for="(metadata, index_metadata) in articles_config[article.article_id]['metadatas']" :key="index_metadata" class="col-lg-2 col-md-4 mb-3"
                    v-if="(metadata.visible === true && metadata.phase === 'CREATION') ? true : metadataVisibleCondition(index_article, index_metadata, metadata)">
                    <div v-if="metadata.options.type === 'select' && command.articles[index_article].metadatas[metadata.id] !== undefined" >
                      <label class="input-label">{{metadata.name}}</label>
                      <fg-input class="select" :name="index_article+'_'+fieldName(metadata.name)" v-model="command.articles[index_article].metadatas[metadata.id].value"
                                v-validate="validateField(metadata.options.rules)"  >
                        <el-select @change="validateOn(index_article+'_'+fieldName(metadata.name))"
                                   @visible-change="article.metadatas[metadata.id].value !== null ? validateOn(index_article+'_'+fieldName(metadata.name)): ''"
                                   :class="errors.first(index_article+'_'+fieldName(metadata.name)) ? 'has-error':''"
                                   :disabled="metadata.disabled" :id="index_article+'_'+fieldName(metadata.name)"
                                   :placeholder="'Choisir un '+metadata.name.toLowerCase()"
                                   v-model="command.articles[index_article].metadatas[metadata.id].value" filterable>
                          <el-option v-for="options in metadata.options.options" :key="options.value" :label="options.value" :value="options.value"></el-option>
                        </el-select>
                        <slot name="helpBlock">
                          <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first(index_article+'_'+fieldName(metadata.name))">
                            {{ errors.first(index_article+'_'+fieldName(metadata.name)) }}
                          </div>
                        </slot>
                      </fg-input>
                    </div>
                    <div v-if="metadata.options.type === 'Datetime'&& command.articles[index_article].metadatas[metadata.id] !== undefined" >
                      <label class="input-label">{{metadata.name}}</label>
                      <fg-input :name="index_article+'_'+fieldName(metadata.name)"
                                v-validate="validateField(metadata.options.rules)"
                                :class="errors.first(index_article+'_'+fieldName(metadata.name)) ? 'has-danger':''"
                                v-model="command.articles[index_article].metadatas[metadata.id].value"
                                addon-left-icon="now-ui-icons far fa-calendar-alt">
                        <flat-picker slot-scope="{focus, blur}" :config="flatpickr_config"
                                     class="datepicker" :placeholder="'Choisir une date'"
                                     @input="validateOn(index_article+'_'+fieldName(metadata.name))"
                                     v-model="command.articles[index_article].metadatas[metadata.id].value">
                        </flat-picker>
                      </fg-input>
                      <slot name="helpBlock">
                        <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first(index_article+'_'+fieldName(metadata.name))">
                          {{ errors.first(index_article+'_'+fieldName(metadata.name)) }}
                        </div>
                      </slot>
                    </div>
                    <div v-if="metadata.options.type === 'Int' && command.articles[index_article].metadatas[metadata.id] !== undefined" >
                      <label class="input-label">{{metadata.name}}</label>
                      <fg-input :placeholder="metadata.name" autocomplete="off" :name="index_article+'_'+fieldName(metadata.name)" v-validate="validateField(metadata.options.rules)" :error="errors.first(index_article+'_'+fieldName(metadata.name))"
                                :disabled="metadata.disabled" v-model="command.articles[index_article].metadatas[metadata.id].value" addon-left-icon="now-ui-icons fas fa-hashtag"/>
                    </div>
                    <div v-if="metadata.options.type === 'String' && command.articles[index_article].metadatas[metadata.id] !== undefined" >
                      <label class="input-label">{{metadata.name}}</label>
                      <fg-input :placeholder="metadata.name" autocomplete="off" :name="index_article+'_'+fieldName(metadata.name)" v-validate="validateField(metadata.options.rules)" :error="errors.first(index_article+'_'+fieldName(metadata.name))"
                                :disabled="metadata.disabled" v-model="command.articles[index_article].metadatas[metadata.id].value" addon-left-icon="now-ui-icons fas fa-tag"/>
                    </div>
                  </div>
                </div>
                <n-button type="danger" class="btn btn-sm btn-danger" style="float: right" @click.native="removeArticleToForm(index_article)">
                  <span><i class="fas fa-trash-alt mr-2"></i> Supprimer</span>
                </n-button>
              </card>

            <div class="row">
              <div class="col-lg-3 col-md-4 mb-3 mr-auto ml-auto">
                <div class="row">
                  <div class="col-10">
                    <label class="input-label">Ajouter un article</label>
                    <fg-input class="select" name="articles" v-model="article_selected">
                      <el-select id="role" placeholder="Choisir un article" v-model="article_selected" filterable>
                        <el-option v-for="article in article_select_options" :key="article.id" :label="article.ref+' - '+article.name" :value="article.id"></el-option>
                      </el-select>
                    </fg-input>
                  </div>
                  <div class="col-2">
                    <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addArticleToForm()">
                      <span><i class="fas fa-plus"></i></span>
                    </n-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-4" @click.native="save()">
                <span> Enregistrer </span>
              </n-button>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Form from 'vform'
import { Select, Option } from 'element-ui'
import flatPicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { French } from 'flatpickr/dist/l10n/fr.js'
import NSwitch from "../../../components/Switch";
import moment from 'moment'
import NumberInput from "../../../components/Inputs/NumberInput";
import auth from "../../../middleware/auth";
import Spinner from "../../../components/Spinner/Circle";

export default {
  name: "CommandForm",
  components: {
    NSwitch,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    NumberInput,
    Spinner
  },
  data() {
    return {
      customer_select: true,
      final_customer_select: true,

      duplicateCommandNumber: false,
      isLoaded: false,
      commercial_select_options: [],
      article_select_options : [],
      customer_select_options : [],
      article_selected: '',

      articles_config: [],

      flatpickr_config: {
        allowInput: true,
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd/m/Y',
        altInput: true,
        mode: 'single',
        dateFormat: 'Y-m-d',
        locale: French,
      },

      command: new Form({
        type: '',
        command_number: '',
        customer_command_number: '',
        command_date: '',
        delivery_date_requested: '',
        preparation_date: '',
        departure_date: '',
        customer: '',         //TODO Get by axios or just a string
        customer_id: '',
        final_customer: '',   //TODO Get by axios or just a string
        final_customer_id: '',
        situation: '',
        comment: '',
        information: '',
        commercial_id: '',
        deliver: false,
        prepared: false,
        urgent: false,
        standby: false,
        articles: []
      }),
      isStateLoadedPreparation: false,
      isStateLoadedDeparture: false
    };
  },
  watch: {
    'command.deliver':
      function(newVal, oldVal){

        if(this.isStateLoadedDeparture){
          this.command.departure_date = newVal ? moment().format('YYYY-MM-DD') : '';
        }else{
          if(oldVal !== undefined){
            this.isStateLoadedDeparture = true
          }
        }
      },
    'command.prepared':
        function(newVal, oldVal){

          if(this.isStateLoadedPreparation){
            this.command.preparation_date = newVal ? moment().format('YYYY-MM-DD') : '';
          }else{
            if(oldVal !== undefined){
              this.isStateLoadedPreparation = true
            }
          }
        },
    'customer_select': function (newVal, oldVal){
      if (newVal !== true){
        this.command.customer_id = null
      }
    },
    'final_customer_select': function (newVal, oldVal){
      if (newVal !== true){
        this.command.final_customer_id = null
      }
    }
  },
  mounted() {
    this.command.type = localStorage.getItem('lastURL')
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`commercial/list`).then((response) => {
        this.commercial_select_options = response.data
    })
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`article/list`).then((response) => {
      this.article_select_options = response.data
      // Récupération des données du tableau dans le formulaire
      if (this.$route.params.command !== undefined) {
        var updateCommand = this.$route.params.command

        this.command.id =                       updateCommand.id
        this.command.command_number =           updateCommand.command_number
        this.command.customer_command_number =  updateCommand.customer_command_number
        this.command.deliver =                  updateCommand.departure_date !== null
        this.command.prepared =                 updateCommand.preparation_date !== null
        this.command.command_date =             moment(updateCommand.command_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.delivery_date_requested =  moment(updateCommand.delivery_date_requested, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.preparation_date =         moment(updateCommand.preparation_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.departure_date =           moment(updateCommand.departure_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.customer =                 updateCommand.customer
        this.command.final_customer =           updateCommand.final_customer
        this.command.customer_id =              updateCommand.customer_id
        this.command.final_customer_id =        updateCommand.final_customer_id
        this.command.situation =                updateCommand.situation
        this.command.comment =                  updateCommand.comment
        this.command.information =              updateCommand.information
        this.command.commercial_id =            updateCommand.commercial_id
        this.command.urgent =                   updateCommand.urgent
        this.command.standby_date =             moment(updateCommand.standby_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.articles = []

        updateCommand.items.forEach( item  => {

          var article = {
            id: item.pivot.id,
            amount: item.pivot.amount,
            article_id: item.id,
            device: item.device,
            metadatas: [],
            name: item.name
          }

          item.metadatas.forEach(metadata => {
            article.metadatas[metadata.metadata_id] = {
              id: metadata.metadata_id,
              name: metadata.metadata.name,
              value: metadata.value,

              item_id: metadata.item_id,
              item_data_id: metadata.id
            }
          })

          var selectedArticle = ''
          this.article_select_options.forEach(article => {
            if(article.id === item.id){
              selectedArticle = article
            }
          })

          // Création d'un tableau répertoriant toutes les conditions d'affichage des champs ("key" du tableau)
          var visibilityCondition = []

          selectedArticle['metadatas'].forEach(metadata =>{
            // Ajout de propriétés génériques à toutes les propriétés
            metadata.visible = true
            metadata.disabled = false
            // Si une valeur "forced value" est définie, alors le champs n'est plus modifiable,
            // et la valeur est directement passé au champs correspondant de l'article
            if(metadata.pivot.parameters['forced value'] !== null){
              metadata.disabled = true
            }

            // Si le champ est un menu déroulant
            if(metadata.options.type === 'select'){
              // Alors je parcours les dépendances pour chaque options et j'alimente le tableau répertoriant les conditions d'affichage
              metadata.options.options.forEach(option => {
                option.dependencies.forEach(dependency => {
                  if(visibilityCondition[dependency]!== undefined){
                    visibilityCondition[dependency].push({'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id})
                  } else {
                    visibilityCondition[dependency] = [{'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id}]
                  }
                })
              })
            }
          })

          // Je parcours les champs de l'article, et si je trouve une correspondance avec le tableau des condtions d'affichage
          selectedArticle['metadatas'].forEach(metadata =>{
            if(visibilityCondition[metadata.name] !== undefined){
              // Alors je change la propriété 'visible' par le tableau de conditions correspondant
              metadata.visible = visibilityCondition[metadata.name]
            }
          })

          // J'ajoute l'article et ces metadata dans un tableau ("key" = article.id) pour retrouver toutes les conditions de chaque metadata
          this.articles_config[selectedArticle.id] = selectedArticle

          this.command.articles.push(article)
        })

        this.isLoaded = true
      }
      else if (this.$route.params.duplicate !== undefined) {
        var duplicateCommand = this.$route.params.duplicate

        this.command.command_number =           duplicateCommand.command_number
        this.command.customer_command_number =  duplicateCommand.customer_command_number
        this.command.delivery_date_requested =  moment(duplicateCommand.delivery_date_requested, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.command.customer =                 duplicateCommand.customer
        this.command.final_customer =           duplicateCommand.final_customer
        this.command.customer_id =              duplicateCommand.customer_id
        this.command.final_customer_id =        duplicateCommand.final_customer_id
        this.command.situation =                duplicateCommand.situation
        this.command.comment =                  duplicateCommand.comment
        this.command.information =              duplicateCommand.information
        this.command.commercial_id =            duplicateCommand.commercial_id
        this.command.urgent =                   duplicateCommand.urgent
        this.command.articles = []

        duplicateCommand.items.forEach( item  => {

          var article = {
            amount: item.pivot.amount,
            article_id: item.id,
            device: item.device,
            metadatas: [],
            name: item.name
          }

          item.metadatas.forEach(metadata => {
            article.metadatas[metadata.metadata_id] = {
              id: metadata.metadata_id,
              name: metadata.metadata.name,
              value: metadata.value,
            }
          })

          var selectedArticle = ''
          this.article_select_options.forEach(article => {
            if(article.id === item.id){
              selectedArticle = article
            }
          })

          // Création d'un tableau répertoriant toutes les conditions d'affichage des champs ("key" du tableau)
          var visibilityCondition = []

          selectedArticle['metadatas'].forEach(metadata =>{
            // Ajout de propriétés génériques à toutes les propriétés
            metadata.visible = true
            metadata.disabled = false
            // Si une valeur "forced value" est définie, alors le champs n'est plus modifiable,
            // et la valeur est directement passé au champs correspondant de l'article
            if(metadata.pivot.parameters['forced value'] !== null){
              metadata.disabled = true
            }

            // Si le champ est un menu déroulant
            if(metadata.options.type === 'select'){
              // Alors je parcours les dépendances pour chaque option et j'alimente le tableau répertoriant les conditions d'affichage
              metadata.options.options.forEach(option => {
                option.dependencies.forEach(dependency => {
                  if(visibilityCondition[dependency]!== undefined){
                    visibilityCondition[dependency].push({'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id})
                  } else {
                    visibilityCondition[dependency] = [{'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id}]
                  }
                })
              })
            }
          })

          // Je parcours les champs de l'article, et si je trouve une correspondance avec le tableau des condtions d'affichage
          selectedArticle['metadatas'].forEach(metadata =>{
            if(visibilityCondition[metadata.name] !== undefined){
              // Alors, je change la propriété 'visible' par le tableau de conditions correspondant
              metadata.visible = visibilityCondition[metadata.name]
            }
          })

          // J'ajoute l'article et ces metadata dans un tableau ("key" = article.id) pour retrouver toutes les conditions de chaque metadata
          this.articles_config[selectedArticle.id] = selectedArticle


          this.command.articles.push(article)
        })
        this.checkDuplicateCommandNumber()

        this.isLoaded = true
      }
      else {
        this.isLoaded = true
      }
    })
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`customer/list/`+localStorage.getItem('lastURL')).then((response) => {
      this.customer_select_options = response.data

      if(this.customer_select_options.length === 0){
        this.customer_select = false
        this.final_customer_select = false
      }
    })
  },
  methods: {
    // Retourne à la liste des commandes
    backToList() {
      this.$router.push({ name: localStorage.getItem('lastURL') !== null ? localStorage.getItem('lastURL') : 'M4' })
    },
    // Met à jour la donnée quantité pour le module "Int"
    updatemodelValue: function (index, $event){
      this.command.articles[index].amount = $event
    },
    // Vérifie les conditions pour afficher la métadonnée sont respectées
    metadataVisibleCondition(index_article, index_metadata, metadata){
      var result = false
      var visibleCondition = metadata.visible


      if(this.command.id === undefined && metadata.phase === 'PREPARATION'){
        return result
      }

      if(metadata.phase === 'PREPARATION'){
        return result
      }

      if(visibleCondition === true){
        return result
      }

      visibleCondition.forEach(condition => {
        if(this.command.articles[index_article].metadatas[condition.metadata_id] === undefined){
          result = false
        } else {
          if(this.command.articles[index_article].metadatas[condition.metadata_id].value === condition.value){
            result = true
          }
        }
      })

      return result
    },
    // Supprime un article de la commande
    removeArticleToForm(index_article){
      this.command.articles.splice(index_article, 1)
    },
    // Ajoute un article au formulaire
    addArticleToForm(){
      this.command.prepared = null
      this.command.deliver = null

      var selectedArticle = ''
      this.article_select_options.forEach(article => {
        if(article.id === this.article_selected){
          selectedArticle = article
        }
      })

      // Création de l'article dans le formulaire ou les données seront enregistrées
      var articleToAdd = {
        article_id: selectedArticle.id,
        device: selectedArticle.device,
        name: selectedArticle.name,
        amount: 1,
        metadatas: []
      }

      // Ajout des propriétés nécéssaire dans l'article pour pouvoir enregistrer ces dernières
      selectedArticle.metadatas.forEach(metadata =>{
        if(metadata.phase === "CREATION"){
          articleToAdd.metadatas[metadata.id] = {id: metadata.id , name: metadata.name , value: null}
        }
      })

      // Création d'un tableau répertoriant toutes les conditions d'affichage des champs ("key" du tableau)
      var visibilityCondition = []

      selectedArticle['metadatas'].forEach(metadata =>{
        // Ajout de propriétés génériques à toutes les propriétés
        metadata.visible = true
        metadata.disabled = false
        // Si une valeur "forced value" est définie, alors le champs n'est plus modifiable,
        // et la valeur est directement passé au champs correspondant de l'article
        if(metadata.pivot.parameters['forced value'] !== null){
          articleToAdd.metadatas[metadata.id].value = metadata.pivot.parameters['forced value']
          metadata.disabled = true
        }

        // Si le champ est un menu déroulant
        if(metadata.options.type === 'select'){
          // Alors je parcours les dépendances pour chaque options et j'alimente le tableau répertoriant les conditions d'affichage
          metadata.options.options.forEach(option => {
            option.dependencies.forEach(dependency => {
              if(visibilityCondition[dependency]!== undefined){
                visibilityCondition[dependency].push({'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id})
              } else {
                visibilityCondition[dependency] = [{'field': this.fieldName(metadata.name), 'value': option.value, 'metadata_id': metadata.id}]
              }
            })
          })
          //Si une valuer apr défaut é été définit dans le pivot, nous l'assignons ici
          if(metadata.pivot.parameters['default value'] !== null){
            articleToAdd.metadatas[metadata.id].value = metadata.pivot.parameters['default value']
          }
        }
        if(metadata.options.type === 'Datetime'){
          if(metadata.pivot.parameters['default value'] === 'now'){
            articleToAdd.metadatas[metadata.id].value = moment().format('YYYY-MM-DD')
          }
        }
      })

      // Je parcours les champs de l'article, et si je trouve une correspondance avec le tableau des condtions d'affichage
      selectedArticle['metadatas'].forEach(metadata =>{
        if(visibilityCondition[metadata.name] !== undefined){
          // Alors je change la propriété 'visible' par le tableau de conditions correspondant
          metadata.visible = visibilityCondition[metadata.name]
        }
      })

      // J'ajoute l'article et ces metadata dans un tableau ("key" = article.id) pour retrouver toutes les conditions de chaque metadata
      this.articles_config[selectedArticle.id] = selectedArticle

      // J'ajoute l'article au formulaire
      this.command.articles.push(articleToAdd)

    },
    // Enregistre la commande
    save(){
      if (this.command.articles.length === 0){
        this.$notify({message: "Vous n'avez seléctionné aucun article", type: 'danger', verticalAlign: 'bottom'})
      } else {
        this.$validator.validateAll().then( value => {
          if(value === true){
            // Envoie des données du formulaire au Back
            if(this.command.id !== undefined){
              this.command.post(process.env.VUE_APP_API_BASE_URL+`command/update`).catch(error => {
                // Notification en cas d'erreur innatendue
                this.$notify({message: "Une erreur est survenue lors de l'enregistrement", type: 'danger', verticalAlign: 'bottom'})
              }).then(response => {
                // Notification en cas de succès & redirection
                this.$notify({message: 'La commande a bien été mis à jour', type: 'success', verticalAlign: 'bottom'})
                this.backToList();
                EventBus.$emit('refreshFiltersNumbers')
              })
            } else {
              this.command.post(process.env.VUE_APP_API_BASE_URL+`command/add`).catch(error => {
                // Notification en cas d'erreur innatendue
                this.$notify({message: "Une erreur est survenue lors de l'enregistrement", type: 'danger', verticalAlign: 'bottom'})
              }).then(response => {
                // Notification en cas de succès & redirection
                this.$notify({message: 'La commande a bien été enregistrée', type: 'success', verticalAlign: 'bottom'})
                this.backToList();
                EventBus.$emit('refreshFiltersNumbers')
              })
            }
          }
        })
      }
    },
    // Vérifie que le champ en paramètre est valide
    validateOn(fieldName){
      this.$validator.validate(fieldName)
    },
    // Renvoie une chaine de caractère avec les éléments du tableau concaténés avec un séparateur entre chaque élément
    validateField(rules){
      var result = '';
      rules.forEach(rule =>{
        result === '' ? result = rule :result = result+'|'+rule
      })
      return result
    },
    // Modifie la chaine de caractère pour là qu'elle corresponde aux conventions,
    // Exemple: "Lecteur de Billet" => "lecteur_De_Billet"
    fieldName(string) {
      var str = string.replace(/ /g,"_");
      return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    },
    // Vérifie que le numéro de commande n,'est pas déjà pris
    checkDuplicateCommandNumber(){
      this.$validator.validate('command_number').then( value => {
        if(value === true){
          this.axios.get(process.env.VUE_APP_API_BASE_URL+`command/available`, {
            params: {
              command_number: this.command.command_number,
              id: this.command.id
            }
          }).catch(error => {

          }).then( response => {
            if(response.data.status === 'not available'){
              this.duplicateCommandNumber = true
            } else {
              this.duplicateCommandNumber = false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">

.active-select {
  z-index: 3;
  position: absolute;
  float: right;
  right: 15px;
  margin-top: -48px;
  height: 38px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.has-error .el-input .el-input__inner{
  border-color: #ffcfcf !important;
  color: #FF3636 !important;
  background-color: rgba(222, 222, 222, 0.1) !important;
}

//.datepicker-form:hover {
//  border: 1px solid #b7b7b7;
//  border-radius: 10px;
//}

.has-error .el-input i.el-select__caret {
  color: #FF3636 !important;
}

.el-select .el-input .el-input__inner:disabled, .el-select .el-input .el-input__inner:disabled:hover, .el-select .el-input [disabled].el-input__inner, .el-select .el-input [disabled].el-input__inner:hover {
  background-color: #8888882e;
  border-color: #e3e3e3;
}
/* BORDER RADIUS START*/
.input-group .form-control:not(:first-child):not(:last-child){
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.input-group-addon.input-group-prepend {
  margin-right: 0;
  border-radius: 10px 0 0 10px;
}

.form-control {
  border-radius: 10px;
}

.btn-round, .form-group .el-input-number .plus-button, .form-group .el-input-number .el-input-number__increase, .form-group .el-input-number .el-input-number__decrease, .el-select .el-input .el-input__inner {
  border-radius: 10px;
}

/* BORDER RADIUS END*/

.line {
  height: 10px;
  width: 85%;
  margin-right: auto;
  margin-left: auto;
  border-bottom: 2px solid #e3e3e3;
}

.switch-input{
  position: absolute;
  width: inherit;
  text-align: center;
}

.datepicker:focus, .datepicker .el-input__inner:focus {
  border: 1px solid #e3e3e3;
}

.form-control:focus, .form-group .el-input__inner:focus {
  border: 1px solid #b7b7b7;
}

.input-group-focus .input-group-addon {
  background-color: #FFFFFF;
  border-color: #b7b7b7;
}

.has-danger.input-group-focus .input-group-addon{
  border-color: #b7b7b7;
  color: #b7b7b7;
}


.input-label{
  margin-left: 40px;
  position: absolute;
  margin-top: -8px;
  background: white;
  z-index: 4;
  padding-right: 3px;
  padding-left: 3px;
  border-radius: 5px;
}

.switch-label{
  position: absolute;
  width: inherit;
  text-align: center;
  margin-top: -5px;
}

.select > .el-select .el-input .el-input__inner {
  color: #000 ;
  background-color: #ffffff ;
  border: 1px solid #e3e3e3 ;
}

.el-select .el-input i.el-select__caret {
  color: #888888;
}

.select > .el-select .el-input .el-input__inner::placeholder {
  color: #888 ;
}
</style>
